import {
  connect,
} from 'react-redux';
import {
  withRouter,
} from '@vroskus/library-navigation';

import {
  actions as authActions,
} from '../../../redux/modules/auth';
import {
  actions as mainActions,
} from '../../../redux/modules/main';

import MainView from './MainView';

// Types
import type {
  $State,
} from '../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './MainView';

const mapStateToProps = ({
  auth,
}: $State): $StateProps => ({
  auth,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  cleanAuthentication: () => dispatchAction(
    authActions.cleanAuthentication(),
  ),
  getRegions: () => dispatchAction(
    mainActions.getRegions(),
  ),
  redirect: (params) => dispatchAction(
    mainActions.redirect(params),
  ),
  setupAuthentication: () => dispatchAction(
    authActions.setupAuthentication(),
  ),
  setupLanguage: () => dispatchAction(
    mainActions.setupLanguage(),
  ),
  setupMainData: (params) => dispatchAction(
    mainActions.setupMainData(params),
  ),
  setupUser: (params) => dispatchAction(
    mainActions.setupUser(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(MainView);

const RoutedComponent = withRouter(ConnectedComponent);

const Component = RoutedComponent;

export default Component;
